import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('The minimum allowed is %{minimum}');

export const validateMinimum = (value, minimum, minimumErrorLabel) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (Number(value) < Number(minimum)) {
    error =
      minimumErrorLabel ||
      errorMessage.i__({
        minimum,
      });
  }

  return error;
};
